import styled from 'styled-components';
import { rem } from 'polished';
import { prop } from '../../../utilities';

export const Title = styled.h1<{
  marginTop?: number;
  marginBottom?: number;
  isCenter?: boolean;
}>`
  font-weight: 500;
  font-size: ${rem(36)};
  line-height: ${rem(48)};
  font-family: ${({ theme }) => theme.font.primary};
  color: ${({ theme }) => theme.colors.textPrimary};
  margin-bottom: ${({ marginBottom }) =>
    marginBottom || marginBottom === 0 ? rem(marginBottom) : rem(56)};
  margin-top: ${({ marginTop }) =>
    marginTop || marginTop === 0 ? rem(marginTop) : rem(32)};
  text-align: ${props => (props.isCenter ? 'center' : 'left')};

  ${({ theme }) => theme.mediab.l925`
    font-size: ${rem(24)};
    line-height: ${rem(32)};
    margin:  0;
    margin-top: ${({ marginTop }) =>
      marginTop || marginTop === 0 ? rem(marginTop) : rem(32)};
      margin-bottom: ${({ marginBottom }) =>
        marginBottom || marginBottom === 0 ? rem(marginBottom) : rem(32)};
  `}
`;
